import classNames from 'classnames';
import * as React from 'react';

type Props<C extends React.ElementType> = React.ComponentProps<C> extends {
  className?: string;
}
  ? React.ComponentProps<C> & { component?: C }
  : never;

/**
 * Renders a panel title.
 *
 * The `component` prop controls what element or component is rendered
 * (defaults to a `h4` element). Any other props are passed through.
 */
export const PanelTitle = <C extends React.ElementType = 'h4'>({
  component = 'h4',
  className,
  ...props
}: Props<C>) => {
  const Component = component;
  return (
    <Component className={classNames('panel-title', className)} {...props} />
  );
};
